import React, { useEffect, useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import { FormatMoney } from "../../../Helpers/FormatNumber";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { CRM_ModalCultivo } from "./CRM_ModalCultivo";
import { CRM_LeyendaAuditoria } from "./CRM_LeyendaAuditoria";
import { CRM_LeyendaDepartamento } from "./CRM_LeyendaDepartamento";

export const CRM_DetalleCultivos = ({ esNuevo, idcliente, cultivoCliente = [], opcionesCultivo = { terreno: [], riego: [] }, soloLectura = false, responsableDepartamento = [] }) => {
  const [cultivos, setCultivos] = useState(cultivoCliente);
  const [openModal, setOpenModal] = useState(false);
  const [registroEditando, setRegistroEditando] = useState(-1);

  // cultivoCliente llega después del primer render (fetch async en CRM_DetalleScreen) — se sincroniza aquí
  useEffect(() => {
    setCultivos(cultivoCliente);
  }, [cultivoCliente]);

  const totalHa = cultivos.reduce((acc, c) => acc + Number(c.hectareas || 0), 0);

  const handleAgregarCultivo = () => {
    setRegistroEditando(-1);
    setOpenModal(true);
  };

  const handleEditarFila = (c) => {
    setRegistroEditando(c.registro);
    setOpenModal(true);
  };

  // El POST de guardado regresa el listado actualizado — se refleja directo, sin volver a consultar aparte
  const handleGuardado = (listadoActualizado) => {
    setCultivos(listadoActualizado || []);
  };

  const handleEliminarFila = (c) => {
    Swal.fire({
      title: "¿Eliminar este cultivo?",
      text: "Este cultivo dejará de aparecer en el expediente del cliente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      request
        .get(`ClientesCultivo/CancelaCultivo?idcliente=${Number(idcliente)}&registro=${c.registro}`)
        .then((result) => setCultivos(result || []))
        .catch((error) => Swal.fire("CULTIVOS", JSON.stringify(error), "error"));
    });
  };

  return (
    <div id="sec-cultivo" className="crm-detalle-card" style={{ scrollMarginTop: 170 }}>
      <div className="crm-detalle-card-header crm-detalle-card-header-actions">
        <div>
          <h3>Cultivos</h3>
          <p>Cultivos registrados del cliente</p>
        </div>
        {!soloLectura && (
          <div className="crm-detalle-card-header-buttons">
            <button type="button" className="btn-primario-solido" onClick={handleAgregarCultivo}>
              <AddCircleOutlineIcon fontSize="small" /> Agregar cultivo
            </button>
          </div>
        )}
      </div>

      {cultivos.length === 0 ? (
        <div className="crm-detalle-card-body">
          <p className="crm-sin-info">Aún no hay cultivos registrados para este cliente.</p>
        </div>
      ) : (
        <div className="crm-detalle-card-body crm-detalle-tabla-wrap">
          <table className="crm-detalle-tabla">
            <thead>
              <tr>
                <th>Cultivo</th>
                <th>Terreno</th>
                <th className="ta-right">Hectáreas</th>
                <th>Riego</th>
                <th>Mes siembra</th>
                <th>Mes cosecha</th>
                <th className="ta-center">.</th>
              </tr>
            </thead>
            <tbody>
              {cultivos.map((c, i) => (
                <tr key={c.registro ?? i}>
                  <td>{c.cultivo}</td>
                  <td>{c.terreno}</td>
                  <td className="ta-right mono">{FormatMoney(c.hectareas, 2)}</td>
                  <td>{c.tipo_riego}</td>
                  <td>{c.messiembra || "-"}</td>
                  <td>{c.mescosecha || "-"}</td>

                  <td className="ta-center">
                    {!soloLectura && (
                      <>
                        <button type="button" className="btn-row-menu" onClick={() => handleEditarFila(c)}>
                          <EditIcon fontSize="small" />
                        </button>
                        <button type="button" className="btn-row-menu" onClick={() => handleEliminarFila(c)}>
                          <CloseIcon fontSize="small" />
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td>Total · {cultivos.length} cultivos</td>
                <td />
                <td className="ta-right mono">{FormatMoney(totalHa, 2)}</td>
                <td colSpan={4} />
              </tr>
            </tfoot>
          </table>
        </div>
      )}

      <CRM_ModalCultivo
        open={openModal}
        onClose={() => setOpenModal(false)}
        idcliente={idcliente}
        registro={registroEditando}
        onGuardado={handleGuardado}
        opcionesCultivo={opcionesCultivo}
      />

      <div className="crm-detalle-card-footer crm-detalle-card-footer-mt">
        <CRM_LeyendaDepartamento responsables={responsableDepartamento} idrel={7} />
        <CRM_LeyendaAuditoria auditoria={cultivos[0]} />
      </div>
    </div>
  );
};
